import { Component } from '@angular/core';
import { RouterLink } from "@angular/router";
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component"
import { Course } from '../../../../models/Course';
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-course-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent
  ],
  templateUrl: './course-configuration.component.html',
  styleUrl: './course-configuration.component.css'
})
export class CourseConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Código', active: true, type: 'text', key: 'code', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Tipo', active: true, type: 'text', key: 'type', sort: true },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Activo', active: true, type: 'boolean', key: 'active', sort: true },
    { name: 'Edad mínima', active: false, type: 'text', key: 'minimum_age', sort: true },
    { name: 'Permiso oficial', active: true, type: 'text', key: 'license.name', sort: false },
    { name: 'Aula virtual', active: true, type: 'text', key: 'virtual_classroom.name', sort: false },
    { name: 'Centro oficial', active: true, type: 'text', key: 'official_center.centerName', sort: false },
    { name: 'Tarifas', active: true, type: 'array', key: 'rates.name', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'code', type: 'text', label: 'Código', validations: 'required' },
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', },
    { name: 'type', type: 'select', label: 'Tipo', validations: 'required', singleSelection: true, optionsList: [{ id: 'Teorico', name: 'Teórico' }, { id: 'Practico', name: 'Práctico' }] },
    { name: 'active', type: 'boolean-switch', label: 'Activo', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'minimum_age', type: 'number', label: 'Edad mínima', validations: 'nullable' },
    { name: 'license_id', type: 'select', label: 'Permiso oficial', validations: 'nullable', url: '/config/license/listAll', singleSelection: true },
    { name: 'virtual_classroom_id', type: 'select', label: 'Aula virtual', validations: 'nullable', url: '/config/virtual-classroom/listAll', singleSelection: true },
    { name: 'official_center_id', type: 'select', label: 'Centro oficial', validations: 'nullable', url: '/config/official-center/listAll', singleSelection: true },
    { name: 'rate_ids', type: 'select', label: 'Tarifas', validations: 'nullable', url: '/config/rate/listAll', singleSelection: false },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'code', type: 'text', label: 'Código', validations: 'required' },
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'type', type: 'select', label: 'Tipo', validations: 'required', singleSelection: true, optionsList: [{ id: 'Teorico', name: 'Teórico' }, { id: 'Practico', name: 'Práctico' }] },
    { name: 'active', type: 'boolean-switch', label: 'Activo', validations: 'required' },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'minimum_age', type: 'number', label: 'Edad mínima', validations: 'nullable' },
    { name: 'license_id', type: 'select', label: 'Permiso oficial', validations: 'nullable', url: '/config/license/listAll', singleSelection: true },
    { name: 'virtual_classroom_id', type: 'select', label: 'Aula virtual', validations: 'nullable', url: '/config/virtual-classroom/listAll', singleSelection: true },
    { name: 'official_center_id', type: 'select', label: 'Centro oficial', validations: 'nullable', url: '/config/official-center/listAll', singleSelection: true },
    { name: 'rate_ids', type: 'select', label: 'Tarifas', validations: 'nullable', url: '/config/rate/listAll', singleSelection: false },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'servicio',
    createButtonTitle: 'Nuevo tipo de curso',
    cols: 2,
    createApiSlug: '/config/course/store',
    formTitle: 'Crear curso',
    formButtonTitle: 'Crear curso',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'tipo de curso',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/config/course/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" /><path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" /><path d="M16 5l3 3" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar el tipo de curso ?',
      deleteRowOnResponse: true,
      actionSlug: '/config/course/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<Course>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/course/index',
    paginate: true,
    name: 'tipos-de-curso',
    actions: this.tableActions,
    exportable: true
  };

  filters: Filter[] = [
    { type: 'search', key: 'code|name|description', operator: 'like', placeholder: 'Código, nombre o descripción' },
    { type: 'multiselect', key: 'type.name', operator: 'in', placeholder: 'Tipo', optionsList: [{ id: 'Practico', name: 'Práctico' }, { id: 'Teorico', name: 'Teórico' }], relation_filter_column: 'type' },
    { type: 'multiselect', key: 'active', operator: 'in', placeholder: 'Estado', optionsList: [{ id: '1', name: 'Activo' }, { id: '0', name: 'Inactivo' }], relation_filter_column: 'active' },
    { type: 'multiselect', key: 'license.name', operator: 'in', placeholder: 'Permiso oficial', url: '/config/license/listAll', relation_filter_column: 'license_id' },
    { type: 'multiselect', key: 'virtual_classroom.name', operator: 'in', placeholder: 'Aula virtual', url: '/config/virtual-classroom/listAll', relation_filter_column: 'virtual_classroom_id' },
    { type: 'multiselect', key: 'official_center.centerName', operator: 'in', placeholder: 'Centro oficial', url: '/config/official-center/listAll', relation_filter_column: 'official_center_id' },
    { type: 'multiselect', key: 'rates.name', operator: 'in', placeholder: 'Tarifas', url: '/config/rate/listAll', relation_filter_column: 'rate_id' },
  ];

  genericCRUD: GenericCRUD<Paginator<Course>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: false
  }
}
